import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sprint-board',
  templateUrl: './sprint-board.component.html',
  styleUrls: ['./sprint-board.component.css']
})
export class SprintBoardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
